module.exports = __webpack_public_path__ + "img/notification-icon-active.f753d985.svg";